import React from 'react'

export default function TestTwo() {

    return (
        <div className={'crm-not-found-layout'}>
            <h1>
                Test Two
            </h1>
        </div>

    );
};

